var WeakMap = require('./_WeakMap');

/** Used to store function metadata. */
var metaMap = WeakMap && new WeakMap;

module.exports = metaMap;



//////////////////
// WEBPACK FOOTER
// ./~/victory-create-container/~/lodash/_metaMap.js
// module id = ./node_modules/victory-create-container/node_modules/lodash/_metaMap.js
// module chunks = 1